/* eslint-disable max-len */
export const staticDictionary = {
  ['hero-heading']: {
    ru: 'твой мир проектирования онлайн',
    en: 'your online design world'
  },
  ['hero-description']: {
    ru: 'Проектным компаниям и проектировщикам для сотрудничества и комфортной работы удаленно',
    en: 'For design companies and designers to collaborate and work comfortably remotely'
  },
  ['get-started']: {
    ru: 'Начать работу',
    en: 'Get started'
  },
  ['need-help']: {
    ru: 'Оставить заявку',
    en: 'Need help?'
  },
  ['our-services']: {
    ru: 'Наши сервисы и продукты',
    en: 'Our services and products'
  },
  ['services-description']: {
    ru: 'Комплексно решаем задачи на всех этапах проектирования от поиска специалиста до готового проекта!',
    en: 'Comprehensive problem solving at all stages of design, from the search for a specialist to the finished project!'
  },
  ['market']: {
    ru: 'Маркет',
    en: 'Market'
  },
  ['market-description']: {
    ru: 'Бесплатный подбор оборудования, Bim-моделей и готовых проектных решений для вашего проекта',
    en: 'Free selection of equipment, Bim models and ready-made design solutions for your project'
  },
  ['job']: {
    ru: 'Работа',
    en: 'Job'
  },
  ['job-description']: {
    ru: 'Поиск и публикация заказов для специалистов и бизнеса',
    en: 'Search and posting of projects for professionals and businesses.'
  },
  ['office']: {
    ru: 'Офис',
    en: 'Office'
  },
  ['office-description']: {
    ru: 'Набор инструментов для управления вашими проектами и эффективного контроля за командой, а также глубокая интеграция с другими сервисами от PlanDi.',
    en: 'A set of tools for managing your projects and effectively controlling the team, as well as deep integration with other services from PlanDi.'
  },
  ['project-vacancies']: {
    ru: 'Заказы и вакансии',
    en: 'Projects and vacancies'
  },
  ['sepcialist-base']: {
    ru: 'База специалистов',
    en: 'The base of specialists'
  },
  companies: {
    ru: 'Компании',
    en: 'Companies'
  },
  factories: {
    ru: 'Заводы',
    en: 'Factories'
  },
  ['ready-projects']: {
    ru: 'Готовые проекты',
    en: 'Ready-made projects'
  },
  ['bim-model-base']: {
    ru: 'База BIM-моделей',
    en: 'BIM model database'
  },
  ['equipment']: {
    ru: 'Оборудование',
    en: 'Equipment'
  },
  ['how-help']: {
    ru: 'Как мы можем вам помочь?',
    en: 'How can we help you?'
  },
  ['everything-for-busines']: {
    ru: 'Все что нужно для бизнеса и специалистов мы объединили в одном месте',
    en: 'Everything necessary for business and specialists has been combined in one place'
  },
  ['for-specialists']: {
    ru: 'Специалистам',
    en: 'For talent'
  },
  ['for-busibes']: {
    ru: 'Бизнесу',
    en: 'For business'
  },
  ['find-work']: {
    ru: 'Найти постоянную или проектно-временную работу',
    en: 'Find a permanent or temporary project job'
  },
  ['create-portfolio']: {
    ru: 'Создать портфолио для продвижения и вести свой Блог.',
    en: 'Create a portfolio for promotion and run your own Blog.'
  },
  ['download-bim']: {
    ru: 'Бесплатно скачивать BIM-модели и пользоваться готовыми проектами.',
    en: 'Download BIM models for free and use ready-made projects.'
  },
  ['projects-in-office']: {
    ru: 'Участвовать в проектах в онлайн офисе.',
    en: ' Participate in projects in the online office.'
  },
  ['participate-projects']: {
    ru: 'Участвовать в проектах в онлайн офисе.',
    en: 'Participate in projects in the online office.'
  },
  ['select-specialist']: {
    ru: 'Подобрать квалифицированных специалистов с портфолио и отзывами',
    en: 'To select qualified specialists with a portfolio and reviews.'
  },
  ['recive-projects']: {
    ru: 'Получать заказы на комплексное проектирование',
    en: 'Receive projects for integrated design.'
  },
  ['monitor-projects']: {
    ru: 'Контролировать и управлять проектом онлайн',
    en: 'Monitor and manage the project online.'
  },
  ['find-bim']: {
    ru: 'Найти BIM-модель, готовый проект или оборудование от производителей',
    en: 'Find a BIM model, a ready-made project or equipment from manufacturers.'
  },
  ['no-time']: {
    ru: 'Нет времени на поиск нужных сотрудников или публикацию ваших проектов?',
    // eslint-disable-next-line quotes
    en: "Don't you have time to find employees or publish your projects?"
  },
  ['our-manages']: {
    ru: 'Наши менеджеры сделают это за вас. Просто оставьте заявку и мы свяжемся с вами как можно скорее!',
    en: 'Our managers will do it for you. Just leave a request and we will contact you as soon as possible!'
  },
  ['our-cases']: {
    ru: 'Наши самые успешные кейсы и отзывы от компаний, с которыми мы работали.',
    en: 'Our most successful cases and reviews from companies we have worked with.'
  },
  ['trust']: {
    ru: 'Нам доверяют',
    en: 'You can trust us '
  },
  ['see-more']: {
    ru: 'Читать дальше',
    en: 'See more'
  },
  ['any-questions']: {
    ru: 'Есть вопросы?',
    en: 'Any questions?'
  },
  ['we-answer']: {
    ru: 'Мы оперативно на них ответим! Отправьте нам заявку или обратитесь напрямую любым удобным для вас способом.',
    en: 'We will respond to them promptly! Send us a request or contact us directly in any way convenient for you.'
  },
  ['name']: {
    ru: 'Как вас зовут?',
    en: 'Name'
  },
  ['phone']: {
    ru: 'Телефон',
    en: 'Phone number'
  },
  ['company-name']: {
    ru: 'Компания',
    en: 'Company name'
  },
  ['message']: {
    ru: 'Сообщение',
    en: 'How can we help you?'
  },
  ['submiting-agreement']: {
    ru: 'Отправляя сообщение я подтверждаю, что ознакомился с политикой обработки персональных данных и политикой конфиденциальности',
    en: 'By submitting this form I confirm that I have read the personal data processing policy and the privacy policy.'
  },
  ['send']: {
    ru: 'Отправить',
    en: 'Send'
  },
  ['review-stron-pos']: {
    ru: 'Руководитель ООО «Stron Holding»',
    en: 'Head of "Stron Holding" LLC'
  },
  ['review-stron-name']: {
    ru: 'Мацковяк Вадим',
    en: 'Vadim Matskovyak'
  },
  ['review-stron-text']: {
    ru: 'Наша компания неоднократно опубликовывает заказы на разделы проекта инженерных сетей на данном сервисе, были оперативно найдены специалисты и добавлены в проект. Благодаря этому сервису нашли стабильных и профессиональных проектировщиков с хорошим опытом работы.',
    en: 'Our company repeatedly publishes orders for sections of the engineering networks project on this service, specialists were promptly found and added to the project. Thanks to this service, we have found stable and professional designers with good work experience.'
  },
  ['review-soft-pos']: {
    ru: 'Руководитель ТОО «Soft Interactive»',
    en: 'The head of "Soft Interactive" LLP'
  },
  ['review-soft-name']: {
    ru: 'Грынькив Александр',
    en: 'Grynkiv Alexander'
  },
  ['review-soft-text']: {
    ru: 'Нарвался на неквалифицированного исполнителя на Вашем сайте, но благодаря вашей быстрой и профессиональной поддержки вопрос был решен моментально. Исполнителя заблокировали. Спасибо Вам большое!',
    en: 'I got caught by an unqualified specialist on your site, but thanks to your quick and professional support, the issue was resolved instantly. The specialist was blocked. thank you very much!'
  },
  ['review-energy-pos']: {
    ru: 'Руководитель ГК «Энергоэффективные технологии»',
    en: 'Head of the Group of Companies "Energy Efficient Technologies"'
  },
  ['review-energy-name']: {
    ru: 'Жданов Дмитрий',
    en: 'Dmitry Zhdanov'
  },
  ['review-energy-text']: {
    ru: 'Зарегистрировавшись в Вашем Онлайн Офисе увидели много недоработок, а именно отсутствие CRM системы, которая бы подходила именно под проектную деятельность, отсутствие мессенджера и возможности создавать видео конференцию с командой. Надеемся, что наши пожелания будут учтены.',
    en: 'We registered in your Online Office and saw a lot of flaws, namely the lack of a CRM system that would be suitable for project activities, the lack of a messenger and the ability to create a video conference with the team. We hope that our wishes will be taken into account.'
  },
  ['review-des-pos']: {
    ru: 'Инженер конструктор',
    en: 'Design Engineer'
  },
  ['review-des-name']: {
    ru: 'Николай Ткаченко',
    en: 'Nikolay Tkachenko'
  },
  ['review-des-text']: {
    ru: 'Работаю на PlanDi недавно, но за короткий срок уже работаю в двух проектах. Понравилось, что, проживая в Киеве могу брать проекты с Москвы и выполнять их онлайн, за это отдельное спасибо',
    en: 'I have been working for PlanDi recently, but in a short time I have already been working on two projects. I liked the fact that, while living in Kiev, I can take projects from Moscow and perform them online, for this special thanks'
  },
  ['review-tech-pos']: {
    ru: 'Техник - проектировщик',
    en: 'Design technician'
  },
  ['review-tech-name']: {
    ru: 'Юсуф Мамедов',
    en: 'Yusuf Mammadov'
  },
  ['review-tech-text']: {
    ru: 'Хочу поделиться радостью и выразить свою благодарность компании Plan Di! Благодаря ее сервисам работать удаленно для проектировщика стало намного легче и безопаснее. А также постоянный поток заказов, что позволяет не сидеть без дела.',
    en: 'I want to share my joy and express my gratitude to Plan Di! Thanks to its services, working remotely has become much easier and safer for the designer. As well as a constant flow of orders, which allows you not to sit around.'
  },
  thanks: {
    ru: 'Спасибо',
    en: 'Thank you'
  },
  projects: {
    ru: 'Проекты',
    en: 'Projects'
  },
  bim: {
    ru: 'BIM-Модели',
    en: 'BIM Models'
  },
  products: {
    ru: 'Товары',
    en: 'Products'
  },
  tenders: {
    ru: 'Заказы',
    en: 'Projects'
  },
  specialists: {
    ru: 'Специалисты',
    en: 'Specialists'
  },
  blog: {
    ru: 'Блог',
    en: 'Blog'
  },
  subscriptions: {
    ru: 'Подписки',
    en: 'Subscriptions'
  },
  ['sign-in']: {
    ru: 'Войти',
    en: 'Sign In'
  },
  documents: {
    ru: 'Документы и соглашения',
    en: 'Documents and agreements'
  },
  ['user-agreement']: {
    ru: 'Пользовательское соглашение',
    en: 'Community Guidelines'
  },
  ['privacy-policy']: {
    ru: 'Политика конфиденциальности',
    en: 'Privacy policy'
  },
  ['processing-policy']: {
    ru: 'Соглашение об обработке персональных данных',
    en: 'Data processing agreement'
  },
  ['user-site-agreement']: {
    ru: 'Правила поведения пользователей',
    en: 'Terms of services'
  },
  ['support-form-success-text']: {
    ru: 'Наши менеджеры свяжутся с вами в ближайшее время',
    en: 'Our managers will contact you soon'
  },
  ['validation-max-len']: {
    ru: 'Максимум %d символов',
    en: 'Maximum %d characters'
  },
  ['validation-min-len']: {
    ru: 'Минимум %d символов',
    en: 'Minimum %d characters'
  },
  ['validation-email']: {
    ru: 'E-mail указан не верно',
    en: 'Email is incorrect'
  },
  ['validation-phone-min']: {
    ru: 'Телефон должен содержать минимум 10 символов и код страны код страны',
    en: 'Phone number must contain at least 10 characters and country code country code'
  },
  ['validation-phone-max']: {
    ru: 'Максимальная длина номера 18 символов',
    en: 'Maximum number length 18 characters'
  },
  ['validation-required']: {
    ru: 'Обязательно для заполнения',
    en: 'Required field'
  },
  ['request-failed']: {
    ru: 'Ошибка при отправке запроса',
    en: 'Error sending request'
  },
  ['hide']: {
    ru: 'Спрятать',
    en: 'Hide'
  }
}
